/**
 * The animate-2d submit paths (AvatarDetail, avatar-editor Step6Confirm) build
 * the error string as `<server code> (HTTP <status>)`, so that an unknown code
 * still shows its status. Mappers that translate the known codes must compare
 * the bare code: an exact match on the whole string never fires once the
 * suffix is there, and every friendly message silently falls back to generic.
 */
export function serverErrorCode(raw: string): string {
  return raw.replace(/ \(HTTP \d+\)$/, '');
}

/**
 * Qavatar#10 (I-416): a normal or beta user hitting a creation/spend route gets 403 with
 * `error: "avatar_creation_reserved"`. The TMA closes every entry for them, so this only fires on a
 * stale token or a revoked role — and then the message must say «reserved», not «try again».
 * Reads the RTK Query error shape (`{ status, data: { error } }`).
 */
export const AVATAR_CREATION_RESERVED = 'avatar_creation_reserved';

export function isCreationReserved(err: unknown): boolean {
  const e = err as { status?: unknown; data?: { error?: unknown } | string } | null | undefined;
  if (e?.status !== 403 || typeof e.data !== 'object' || e.data === null) return false;
  return e.data.error === AVATAR_CREATION_RESERVED;
}
